import { render, staticRenderFns } from "./CampoTextareaBase.vue?vue&type=template&id=42369923&scoped=true"
import script from "./CampoTextareaBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoTextareaBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoTextareaBase.vue?vue&type=style&index=0&id=42369923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42369923",
  null
  
)

export default component.exports